// * Bootstrap libraries
import "./_bootstrap";
import './vendorjs/alpine.vendor';

// * Any other global site-wide JavaScript should be placed below.

// Dynamically calculate and set `--vh` for iOS viewports
function setDynamicVH() {
  // Calculate 1vh in pixels.
  try {
    const vh = window.innerHeight * 0.01;
    // You can optionally use `vh` here, e.g., apply it to a CSS variable
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  } catch (error) {
    console.error('An error occurred while calculating vh:', error);
  }
}

// Run the function on page load and resize.
setDynamicVH();
window.addEventListener('resize', setDynamicVH);

(function ($, Drupal, drupalSettings) {

  // Replace contrib ajax throbber with a custom one.
  if (typeof Drupal !== 'undefined' && Drupal.Ajax) {
    Drupal.Ajax.prototype.ajaxBeforeSendOriginal = Drupal.Ajax.prototype.beforeSend;
    Drupal.Ajax.prototype.beforeSend = function (xmlhttprequest, options) {
      Drupal.Ajax.prototype.ajaxBeforeSendOriginal.call(this, xmlhttprequest, options);
      options.completeOriginal = options.complete;
      options.complete = Drupal.Ajax.prototype.options_complete;

      // Before ajax logic.
      $('.ea-spinner').last().removeClass('hidden');
    };

    Drupal.Ajax.prototype.options_complete = function (xmlhttprequest, status) {
      this.completeOriginal.call(this, xmlhttprequest, status);

      // After ajax logic.
      $('.ea-spinner').addClass('hidden');
    };
  }

  // Custom navbar handler.
  Drupal.behaviors.navbarMenu = {
    attach: function (context, settings) {
      $(once('navbar-processed', '.navbar-toggler', context)).on('click', function (event) {
        $('.main-content').toggleClass('hidden');

        let $navbar = $('#navbar-menu');
        let $this = $(this);

        let expanded = $this.attr('aria-expanded');
        expanded = expanded === 'false' ? 'true' : 'false';

        $this.attr('aria-expanded', expanded);
        $navbar.toggleClass('desktop');
      });

      // Show main content on tablet orientation change from md to lg when mobile menu was open.
      once('navbar-resize-processed', 'html').forEach(function () {
        $(window).on('orientationchange', function (event) {
          $(window).one('resize', function() {
            // Post-orientation code here.
            if (window.matchMedia('(min-width: 992px)').matches) {
              let $navbar = $('#navbar-menu');
              let $navbarToggler = $('.navbar-toggler');

              let expanded = $navbarToggler.attr('aria-expanded');
              if ($navbarToggler.attr('aria-expanded') === 'true') {
                $navbarToggler.attr('aria-expanded', 'false');
                $navbar.addClass('desktop');

                $('.main-content').removeClass('hidden');
              }
            }
          });
        });
      });
    }
  };

  // Dynamically calculate `--vh` for iOS viewports
  Drupal.behaviors.fixUIDialogHeight = {
    attach: function (context, settings) {
      try {
        $(once('ajax-modal', 'body')).on('dialogContentResize.digitalumni-modal', function(event, ui) {
          // Calculate 1vh dynamically
          const vh = window.innerHeight * 0.01;
          let $toolbar = $('#toolbar-bar');

          // Apply the corrected height (100 * vh).
          $('#digitalumni-modal, .min-h-full-corrected').each(function() {
            let $this = $(this);

            // Check if the screen width is mobile (example: 576px or smaller).
            if ($toolbar.length && $this.hasClass('min-h-full-corrected') &&
              window.matchMedia('(max-width: 576px)').matches) {
              const toolbarRect = $toolbar[0].getBoundingClientRect();
              // Visible admin toolbar height on screen.
              const visibleToolbarHeight = Math.max(0, toolbarRect.bottom);
              // Apply fullscreen popup margin for admin toolbar according to the eight of
              // visible toolbar, e.g. when we scroll a page down toolbar gradually decreases
              // & disappears eventually, so the margin should adapt but only for a fullscreen popup.
              $this.css('margin-top', `${visibleToolbarHeight}px`);
            }

            // IOS has dynamic popup overlay gap at bottom, prevent this.
            // Avoid jQuery dialog styles dynamic concurrency flashing for IOS viewport case.
            $this.css('min-height', `${vh * 100}px`);
            $this.css('height', `${vh * 100}px`);
            $this.css('max-height', `${vh * 100}px`);
            $this.find('.close-modal > .relative').removeClass('ohidden');
          });
        });
      } catch (error) {
        console.error('An error occurred while processing dynamic styles:', error);
      }
    }
  };

  // Dynamically calculate height of cards components & if it exceeds 50% make it 100%
  Drupal.behaviors.cardDynamicHeight = {
    attach: function (context, settings) {

      try {
        let resizeObserver;

        let resizeOverlay = function (newHeight, paddindsHeight, $targetDiv) {
          // Example: Adjust the height if it exceeds 50% of the parent's height
          const parentHeight = $targetDiv.parent().height();

          let $textClampedElement = $targetDiv.find('.text-clamp-2');

          // If content exceeds inner region & overflows padding zone then clamp the title.
          if (newHeight > (parentHeight - paddindsHeight)) {
            $textClampedElement.css('-webkit-line-clamp', '1');
            $textClampedElement.css('line-clamp', '1');

            // newHeight = $targetDiv.height() + paddindsHeight;
            // If clamped title content exceeds inner region & overflows padding zone then hide other elements.
            // if ((newHeight - 25) > (parentHeight - paddindsHeight)) {
            //   $targetDiv.children().not($textClampedElement.parent()).hide();
            // }
            // else {
            //   $targetDiv.children().not($textClampedElement.parent()).show();
            // }

            $targetDiv.css('height', '100%');
          } else {
            if (newHeight > parentHeight * 0.6) {
              $targetDiv.css('height', '100%');
            } else {
              $targetDiv.css('height', '');
            }

            $textClampedElement.css('-webkit-line-clamp', '');
            $textClampedElement.css('line-clamp', '');

            // $targetDiv.children().not($textClampedElement.parent()).show();
          }
        }

        if (typeof resizeObserver === 'undefined') {
          // Check if ResizeObserver is supported
          if ('ResizeObserver' in window) {
            resizeObserver = new ResizeObserver(function (entries) {
              entries.forEach(entry => {
                // Get the actual height.
                let $targetDiv = $(entry.target);
                $targetDiv.css('height', '');
                let newHeight = $targetDiv.height();

                const paddingTop = parseFloat($targetDiv.css('padding-top'));
                const paddingBottom = parseFloat($targetDiv.css('padding-bottom'));

                newHeight = newHeight + paddingTop + paddingBottom;

                resizeOverlay(newHeight, paddingTop + paddingBottom, $targetDiv);
              });
            });
          }
        }

        once('card-height', '.card .image-overlay').forEach(function (targetDiv) {
          let $targetDiv = $(targetDiv);
          let newHeight = $targetDiv.height();
          const paddingTop = parseFloat($targetDiv.css('padding-top'));
          const paddingBottom = parseFloat($targetDiv.css('padding-bottom'));
          newHeight = newHeight + paddingTop + paddingBottom;

          resizeOverlay(newHeight, paddingTop + paddingBottom, $targetDiv);

          // Start observing the target div.
          if (typeof resizeObserver !== 'undefined') {
            resizeObserver.observe(targetDiv);
          }
        });

      } catch (error) {
        console.error('An error occurred while processing dynamic card components styles:', error);
      }
    }
  };

  if (typeof Drupal !== 'undefined' && Drupal.AjaxCommands) {
    /**
     * Updates the participation status on the page based on the given Ajax response.
     *
     * This command is used to modify the DOM element to reflect a change in participation status.
     *
     * @function
     * @param {object} ajax - The Ajax object responsible for this operation.
     * @param {object} response - The server-side response containing the necessary data for the update.
     * @param {string} response.selector - The CSS selector used to find the DOM element to update.
     * @param {string} response.status - The new status to set on the targeted element.
     * @param {boolean} response.replace - Indicates whether the status text should be replaced or appended.
     * @param {object} status - The status object associated with the Ajax command (optional).
     */
    Drupal.AjaxCommands.prototype.participationStatusUpdate = function (ajax, response, status) {
      if (response.participation_status === 'join') {
        window.location.reload(true);
      } else {
        $('#group-join-btns .link-button.btn:not(' + response.participation_status + ')').addClass('gray');
        $('#group-join-btns .link-button.btn.' + response.participation_status).removeClass('gray');
      }
    };
  }

})(jQuery, Drupal, drupalSettings, );
